module.exports = __webpack_public_path__ + "img/9788990878052.634dfd5f.jpg";